import { render, staticRenderFns } from "./px_index.vue?vue&type=template&id=2370de44&scoped=true"
import script from "./px_index.vue?vue&type=script&lang=js"
export * from "./px_index.vue?vue&type=script&lang=js"
import style0 from "./px_index.vue?vue&type=style&index=0&id=2370de44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370de44",
  null
  
)

export default component.exports